module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3Fc3ed2JpmE6IOEiqaES46-247ee19c277219b5810bbadc3c2d277b.jpg";